import store from '@/store'

export default (name, storeModule) => {
  const exists = store._modules.root._children[name]
  if (!exists) store.registerModule(name, storeModule)
}
